import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'unfonts.css';
import App from './App';
import '../index.css';
import { reportWebVitals } from '../utils/web-vitals';

Sentry.init({
  dsn: 'https://fa3722b68b8023a5937699e0f4c608e1@o4511109857935360.ingest.de.sentry.io/4511109862588496',
  tunnel: '/api/sentry-tunnel',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: window.location.hostname === 'admin.orionex.id' ? 'production'
    : window.location.hostname === 'admin-dev.orionex.id' ? 'staging'
    : 'development',
  // Performance: 20% in production, 100% in staging/dev
  tracesSampleRate: window.location.hostname === 'admin.orionex.id' ? 0.2 : 1.0,
  // Session replay: 10% of sessions, 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Only send errors from our domains
  allowUrls: [/admin(-dev)?\.orionex\.id/, /localhost/],
  // Ignore common noise
  ignoreErrors: [
    'ResizeObserver loop',
    'Non-Error promise rejection',
    /Loading chunk .* failed/,
  ],
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log performance metrics
reportWebVitals(console.log);